module.exports = __webpack_public_path__ + "img/img-voice01.feaeb06f.png";